import { useState } from "react";
import { ImageOff } from "lucide-react";

// Placeholder shown on broken images so users don't see broken-icon glyphs.
const FALLBACK =
  "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 3'><rect width='4' height='3' fill='%230a0a0a'/></svg>";

/**
 * Drop-in replacement for <img> with:
 *  - skeleton/shimmer while loading
 *  - elegant fallback when the source fails
 *  - lazy by default
 *  - all other <img> props passed through
 */
export default function SmartImage({ src, alt = "", className = "", containerClassName = "", loading = "lazy", ...rest }) {
  const [loaded, setLoaded] = useState(false);
  const [failed, setFailed] = useState(false);

  return (
    <div className={`relative overflow-hidden ${containerClassName}`}>
      {!loaded && !failed && (
        <div
          aria-hidden
          className="absolute inset-0 bg-gradient-to-br from-[#11140f] via-[#1a1d18] to-[#11140f] animate-pulse"
        />
      )}
      {failed ? (
        <div className="absolute inset-0 flex flex-col items-center justify-center bg-[#0a0d0b] text-white/30 gap-2">
          <ImageOff size={26} strokeWidth={1.4} />
          <span className="text-[0.62rem] tracking-[0.22em] uppercase">Image unavailable</span>
        </div>
      ) : (
        <img
          {...rest}
          src={src || FALLBACK}
          alt={alt}
          loading={loading}
          decoding="async"
          onLoad={() => setLoaded(true)}
          onError={() => {
            setFailed(true);
            setLoaded(true);
          }}
          className={`${className} transition-opacity duration-500 ${loaded ? "opacity-100" : "opacity-0"}`}
        />
      )}
    </div>
  );
}
